<!-- 配件待入数据 -->
<template>
  <div v-loading="loading">
    <div class="search-ctn">
      <div class="search-ctn-left">
          <el-button
            size="small"
            icon="el-icon-sort"
            class="search-btn btn-primary"
            @click="allSyncStaff"
            style="height: 32px"
            >全部同步</el-button
          >
          <span style="color:red">（✳ 请百分百确认员工手机号与钉钉中员工手机号一致，否者无法同步关联，从而获得考勤数据）</span>
      </div>
    </div>
    <div class="table-ctn as-table-i">
      <ux-grid border
             show-overflow
             ref="plxTable"
             keep-source
             :data="tableData"
             :highlightCurrentRow="false"
             :edit-config="{trigger: 'manual', mode: 'row'}">
             <ux-table-column field="JobNum" title="工号" min-width="100">
             </ux-table-column>
             <ux-table-column field="Name" title="姓名" min-width="120">
             </ux-table-column>
             <ux-table-column field="PhoneNum" title="手机号码" min-width="140" edit-render>
              <template v-slot:header="{ column }">
                 <span>{{ column.title }}</span>
               </template>
               <template v-slot:edit="{ row }">
                  <el-input
                      v-model="row.PhoneNum"
                      type="number"
                      size="small"
                      style="width: 100%"></el-input>
               </template>
             </ux-table-column>
                <ux-table-column field="SyncState" title="同步状态" min-width="100">
                    <template v-slot="{ row }">
                 <span class="statecls" :style="row.IsSync?'color:red':''">{{ row.SyncState }}</span>
               </template>
             </ux-table-column>
               <ux-table-column title="操作" width="160">
                 <template v-slot="{ row }">
                    <div class="ops-ctn">
                         <el-button
                    type="text"
                    size="mini"
                    @click="syncSingleStaff(row)"
                    v-if="!row.IsSync"
                  >同步</el-button>
                        <!--判断行是否激活了, 编辑按钮执行的方式就是为了去激活-->
                        <template v-if="$refs.plxTable.isActiveByRow(row)">
                            <el-button   type="text" @click="saveEvent(row)" >保存</el-button>
                            <el-button   type="text" style="color:orange" @click="cancelRowEvent(row)">取消</el-button>
                       </template>
                       <template v-else>
                           <el-button   type="text" @click="editRowEvent(row)">修改手机号</el-button>
                        </template>
                    </div>
                 </template>
               </ux-table-column>
      </ux-grid>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  props: {
    DeviceId: {
      type: String
    }
  },
  data() {
    return {
      loading: false,
      tableData: []
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    syncSingleStaff(row) {
      this.loading = true;
      let that = this;
      let url = "/api/AttendanceSystem/SyncStaffDingDevice";
      that.$util
        .axiosPost({
          url: url,
          data: { StaffId: row.StaffId, PhoneNum: row.PhoneNum },
          hideLoading: true
        })
        .then(res => {
          if (res.errcode == 0) {
            that.$util.successMsg(res.errmsg);
            that.tableData.forEach(item => {
              if (item.StaffId == row.StaffId) {
                item.IsSync = true;
                item.SyncState = "已同步";
                return;
              }
            });
          } else this.$util.errorMsg(res.errmsg);
        })
        .catch(() => {})
        .finally(() => {
          that.loading = false;
        });
    },
    allSyncStaff() {
      this.loading = true;
      let that = this;
      if (that.tableData.length > 0) {
        let staffIds = [];
        for (let index = 0; index < that.tableData.length; index++) {
          let id = that.tableData[index].StaffId;
          if (!that.tableData[index].IsSync) staffIds.push(id);
        }
        let url = "/api/AttendanceSystem/SyncStaffDingDevice";
        that.$util
          .axiosPost({
            url: url,
            data: { StaffIds: staffIds },
            hideLoading: true
          })
          .then(res => {
            if (res.errcode == 0) {
              that.$util.successMsg(res.errmsg);
              that.getTableData();
            } else that.$util.errorMsg(res.errmsg);
          })
          .catch(() => {})
          .finally(() => {
            that.loading = false;
          });
      }
    },
    getTableData() {
      this.loading = true;
      this.$util
        .axiosGet({
          url: "/api/AttendanceSystem/GetStaffSyncDingTalkeDatas",
          data: {
            deviceId: this.DeviceId
          },
          hideLoading: true
        })
        .then(res => {
          this.loading = false;
          let data = res.data;
          if (!data) data = [];
          this.tableData = data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 点击保存
    saveEvent(row) {
      // 判断是否发生改变
      //console.log(this.$refs.plxTable.isUpdateByRow(row));
      // 你也可以不使用这个判断，我是给示例，没做个性化需求
      if (this.$refs.plxTable.isUpdateByRow(row)) {
        // ...保存相关的逻辑（后端的呀，或者前端的呀）
        // 清除表格激活状态
        this.$util
          .axiosPost({
            url: "/api/AttendanceSystem/SaveStaffPhoneNum",
            data: { StaffId: row.StaffId, PhoneNum: row.PhoneNum }
          })
          .then(res => {
            if (res.errcode == 0) {
              this.$util.successMsg(res.errmsg);
              this.$refs.plxTable.clearActived().then(() => {
                // 局部保存，并将行数据恢复到初始状态（如果 第二个参数record 为空则不改动行数据，只恢复状态）
                // 你不执行这个reloadRow，代表下次进来你上面的这个if还是会执行，不然下次点击保存，还是保存成功哦！状态没改变哦
                this.$refs.plxTable.reloadRow(row, null, null);
                // 如果，假如你保存了后端给你个当前行的row，那么你需要赋值给表格行呢，你就需要把后端给你的row填到第二个参数位置
                // this.$refs.plxTable.reloadRow(row, 后端的row, null)
                // 第三个参数呢就是只改变当前行中的call单个单元格。第三个参数是row中的字段名（field属性的值）
              });
            } else this.$util.errorMsg(res.errmsg);
          })
          .catch(() => {});
      }
    },
    // 点击编辑按钮，激活行状态-> 为编辑状态
    editRowEvent(row) {
      this.$refs.plxTable.setActiveRow(row);
    },
    // 取消
    cancelRowEvent(row) {
      // 清除表格激活状态
      this.$refs.plxTable.clearActived().then(() => {
        // 还原行数据
        this.$refs.plxTable.revertData(row);
      });
    }
  }
};
</script>
<style lang="less" scoped>
.data-count {
  padding: 5px;
  display: flex;
  flex-direction: row-reverse;
}
.data-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 12.5%;
  border-left: 1px solid @border4Color;
  border-right: 1px solid @border4Color;
  > p:nth-child(1) {
    margin-bottom: 5px;
  }
}
.search-ctn {
  margin-top: 0px;
  margin-bottom: 0px;
  min-height: 0px;
}
</style>
<style lang="less">
.as-table-i {
  .elx-table {
    .elx-body--row.row--hover,
    .elx-body--row.row--hover.row--stripe {
      background-color: #dcdee1;
    }
    .elx-table--body-wrapper {
      .elx-body--row {
        td {
          height: 32px;
          line-height: 32px;
        }
      }
      .elx-cell {
        height: 32px;
        padding: 0px;
      }
      .elx-cell--label {
        padding-left: 10px;
      }
      .ops-ctn {
        padding-left: 10px;
      }
      .statecls {
        padding-left: 10px;
      }
      .el-button {
        padding: 0;
        line-height: 32px;
      }
    }
    .elx-table--footer-wrapper {
      margin-top: 0 !important;
    }
  }
}
</style>